import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import About from "./views/About.vue";
import SoldOut from "./views/SoldOut.vue";
import ColorMe from "./views/ColorMe.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/color',
      name: 'color',
      component: ColorMe,
    },
    {
      path: '/color/:major',
      name: 'custom-color',
      component: ColorMe,
    },
    {
      path: "/sold-out",
      name: "sold-out",
      component: SoldOut,
    },
  ],
});
